import { useState, useEffect } from 'react';

/**
 * Je okno v mobilní šířce? Jeden práh pro celou aplikaci (768 px), ať se
 * nerozjede mezi moduly a modaly.
 *
 * Stránky si ho většinou počítají samy z `window.innerWidth` + `resize`, protože
 * si k němu drží i další stavy. Modaly ale mají jen jednu otázku — zdola, nebo
 * na střed? — a opisovat kvůli ní pět řádků do každého je zbytečné.
 *
 * Přes `matchMedia`, ne `resize`: prohlížeč pak přepočítává jen při překročení
 * prahu, ne při každém pixelu tažení okna.
 */
export default function useJeMobil(prah = 768) {
    const [jeMobil, setJeMobil] = useState(
        () => typeof window !== 'undefined' && window.innerWidth < prah
    );

    useEffect(() => {
        const mq = window.matchMedia(`(max-width: ${prah - 1}px)`);
        const zmena = (e) => setJeMobil(e.matches);
        setJeMobil(mq.matches);
        mq.addEventListener('change', zmena);
        return () => mq.removeEventListener('change', zmena);
    }, [prah]);

    return jeMobil;
}
